// extracted by mini-css-extract-plugin
module.exports = {"link-no-style":"global_link-no-style__21yy9","linkNoStyle":"global_link-no-style__21yy9"};